import { helpers } from '@vuelidate/validators';
import type { AuthAuthIsEmailBusyRouteRpc } from '@repo/contract';
import { fetchRpc } from '../../transport/fetch-rpc';

export const emailExistsRule = helpers.withMessage(
  'Email does not exist',
  helpers.withAsync(
    async (email: string) => {
      const { isBusy } = await fetchRpc<typeof AuthAuthIsEmailBusyRouteRpc>(
        '/api/rpc/auth/auth/is-email-busy',
        { email },
      );

      return !!isBusy;
    },
  ),
);
